import { Fragment } from 'react'
import { ReactNode } from 'react'
import { SCROLL_TOP_PARAMS } from '@/presentation/helpers'
import useRouteChange from '@/presentation/hooks/navigate/use-route-change'
import { useMatches } from 'react-router-dom'
import { useApplicationSettings } from '@/presentation/contexts/application/application-settings-provider'
import PathConstants from '@/main/routes/path-contants'
import { Category } from '@/domain/models/content/category'

const { SKILLS, INSTITUTION, INSTITUTIONS } = PathConstants.Routes

const GLOBAL_TYPE_SEARCH_ENABLED_ROUTES_ID = [
  SKILLS.name.toLowerCase(),
  INSTITUTION.name.toLowerCase(),
  INSTITUTIONS.name.toLowerCase(),
  Category.Enum.COURSE.name.toLowerCase(),
  Category.Enum.LANGUAGE.name.toLowerCase(),
  Category.Enum.HIGH_SCHOOL.name.toLowerCase(),
  Category.Enum.TECHNICAL.name.toLowerCase(),
  Category.Enum.UNDERGRADUATE.name.toLowerCase(),
  Category.Enum.GRADUATE.name.toLowerCase(),
  Category.Enum.MENTORING.name.toLowerCase()
]

export default function RouterMiddleware({ children }: { children: ReactNode }): JSX.Element {
  const { settings, updateSettings } = useApplicationSettings()
  const matches = useMatches()
  const currentRoute = matches[matches.length - 1]

  useRouteChange(() => {
    setTimeout(() => {
      window.scrollTo(SCROLL_TOP_PARAMS)
    }, 0)

    const currentRouteId = currentRoute?.id

    if (!currentRouteId) return

    const isGlobalSearchEnabled = GLOBAL_TYPE_SEARCH_ENABLED_ROUTES_ID.includes(
      currentRouteId as string
    )

    updateSettings({
      ...settings,
      globalSearch: {
        enabledSearchType: isGlobalSearchEnabled,
        route: {}
      }
    })
  })

  return <Fragment>{children}</Fragment>
}
